<div>
  <section>
    <div class="container">
      <div class="row pt-4">
        <div class="col-md-12">
          <h1>Report your injury or illness</h1>
        </div>
      </div>
    </div>
  </section>

  <section class="green">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h2 class="">Getting started</h2>
        </div>
      </div>
    </div>
  </section>

  <section class="py-1">
    <div class="container">
      <div class="row">
        <div class="col">
          <div><b>Did you also sustain a physical injury because of this incident?</b></div>
          <div>
            For example, did you experience a sprain, cut, fracture, concussion, bruise, burn
            (chemical or fire), needlestick, or smoke inhalation?
          </div>
        </div>
      </div>
    </div>
  </section>

  <!--  DESKTOP MENU  -->

  <section class="green">
    <div class="container">
      <div class="row fadein">
        <div class="col-lg-4 col-md-6" style="">
          <a
            id=""
            class="cardlink"
            (click)="
              onTileClick('SustainedPhysicalInjuryYesClicked', '/eligibilityQuizBeforeYouBegin', {
                key: 'injuryType',
                value: 'Mental health condition'
              })
            "
          >
            <div class="infocard bg-white my-2">
              <h3 class="text-dark pt-0">Yes, I did</h3>
              <div>I sustained a physical injury too</div>
            </div>
          </a>
        </div>

        <div class="col-lg-4 col-md-6" style="">
          <a
            id=""
            class="cardlink"
            (click)="onTileClick('SustainedPhysicalInjuryNoClicked', '/eligibilityQuizChannels')"
          >
            <div class="infocard bg-white my-2">
              <h3 class="text-dark pt-0">No, I did not</h3>
              <div>I am only claiming a mental health injury</div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </section>

  <!--MAIN ACTION -->

  <section class="mt-4" style="">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <a
            class="btn-outline-blue btn-md btn mr-3"
            [routerLink]="['/eligibilityQuizBeforeYouBegin']"
            >Back</a
          >
        </div>
      </div>
    </div>
  </section>

  <!--SUPPORT LINE -->
  <section class="">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <hr />
          <div>
            <strong
              >Have a question about reporting your injury? Please call our Teleclaim team at
              <a href="#">604.231.8888</a> (or toll-free at <a href="#">1.888.967.5377</a>).</strong
            >
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
